import React, { forwardRef } from "react"
import { logTool } from "@jsUtils"

import analytics from "./analytics.utils"

const log = logTool(false)

const { getAnalytics, convertToDataProps } = analytics

/**
 * Higher Order Component to apply the correct attributes to a wrapped component.
 * We also strip our config props and pass the rest down to the children
 * @param {object} UseComponent Wrapped component
 * @param {boolean} group - if we need to group the props or not. (see below)
 * @param {object} props - react props
 * @param {string} props.ascope - prefix path for ANALYTICS constant
 * @param {string|object} props.adata - full path from scope prefix for ANALYTICS constant data or { content: [string] }
 * @return {function}              returns a functional component
 * If group === true, then the props are bundled in a property that can be easily spread over a child
 * component when present (dataProps). This is necessary when the wrapped component does not automatically propagate
 * props down through the desired component
 */
const Analytics = (UseComponent, group = false) =>
  forwardRef((props, ref) => {
    const { children, ascope = "", adata = "" } = props

    const forwardProps = {}
    const ourKeys = ["ascope", "adata"]
    // forward all props but ours
    Object.keys(props).forEach(v => {
      if (!ourKeys.includes(v)) {
        forwardProps[v] = props[v]
      }
    })

    const analyticsData = getAnalytics(ascope, adata)
    const dataProps = convertToDataProps(analyticsData)
    const componentProps = group
      ? { dataProps, ...forwardProps }
      : { ...dataProps, ...forwardProps }

    log("Analytics Item:", group, {
      ascope,
      adata,
      analyticsData,
      props,
      forwardProps,
      dataProps,
      UseComponent
    })

    return (
      <UseComponent ref={ref} {...componentProps}>
        {children}
      </UseComponent>
    )
  })

export default Analytics
